import { useMemo } from 'react';
import { useGetMetaDataQuery } from '../redux/services/api';

/**
 * Custom hook that checks if a metadata key has a value of 'true'.
 *
 * @param key - The metadata key to check
 * @param defaultValue - The default value to return if the key is not found (defaults to false)
 * @returns True if the metadata key exists and has a value of 'true', otherwise returns 'false' or the defaultValue
 */
const useIsMetadataKey = (key: string, defaultValue: boolean = false) => {
  const { data: metaData } = useGetMetaDataQuery();

  const isMetadataKey = useMemo(() => {
    const found = metaData?.find((data) => data.key === key);
    if (found) {
      return found.value === 'true';
    }
    return defaultValue;
  }, [metaData, defaultValue]);

  return isMetadataKey;
};

export default useIsMetadataKey;
